<template>
	<div class="evaluation-scoped evaluation-resume-scoped container">
		<div class="resume-doc-wpr box-shadow-small border-radius" v-if="baseInfo">
			<div class="" style="padding-top: 30px;">
				<div class="mb-15">
					<thumbnail :text="baseInfo.resume.name" :gender="baseInfo.resume.gender==1?'man':'woman'" :font-size="16" :width="110"></thumbnail>
					<el-row class="mt-10 text-center" :gutter="10">
						<el-col :span="8">应聘职位：{{ baseInfo.position.name }}</el-col>
						<el-col :span="8">应聘部门：{{ baseInfo.position.deptNames }}</el-col>
						<el-col :span="8">手机号：{{ baseInfo.resume.mobilePhone }}</el-col>
					</el-row>
				</div>
			</div>
			<div style="margin-top: 50px;" class="clearfix">
				<!--<el-button type="primary" @click="showEdit=true" style="float: right;margin-bottom: 20px;">添加评价</el-button>-->
			</div>
			<div v-if="evaInfo && !evaInfo.list.length">
				<empty-tip></empty-tip>
			</div>
			<div v-else class="resume-doc">
				<!--查看评价表格-->
				<div class="history-form" v-if="evaInfo && evaInfo.list.length">
					<el-table class="evaluation-item" row-class-name="evaluate-row" :show-header="false"
							  v-for="(item, index) in evaInfo.list" :data="[{}]" :key="index">
						<el-table-column>
							<template slot-scope="scope">
								<div class="evaluate-row">
									<div class="isView">
										<el-row class="mt-15">
											<el-col :span="8"><span class="txt-label">定薪者：</span>{{item.name}}
											</el-col>
											<el-col :span="8"><span class="txt-label">时间：</span>{{item.updateTime}}
											</el-col>
										</el-row>
										<el-row class="mt-15">
											<el-col :span="8"><span class="txt-label">定级：</span>{{item.secLevel}}
											</el-col>
											<el-col :span="8"><span class="txt-label">定薪：</span>{{item.paymentLevel}}
											</el-col>
											<el-col :span="8"><span class="txt-label">offer标准：</span>{{item.paymentMonth}}/月
											</el-col>
										</el-row>
										<el-row class="mt-15 mb-15">
											<el-col><span class="txt-label">备注：</span>
												<pre class="multi-row-content">{{item.remark}}</pre>
											</el-col>
										</el-row>
									</div>
								</div>
							</template>
						</el-table-column>
					</el-table>
				</div>
			</div>
		</div>
		<modify-salary-dialog ref="modifySalaryDialog" @reload="getEvaList"></modify-salary-dialog>
	</div>
</template>

<script>
import Thumbnail from 'components/thumbnail'
import SelectMapMixin from 'mixins/selectMapMixin'
import ModifySalaryDialog from 'views/operation/modifySalaryDialog'
import EmptyTip from 'views/common/empty'

export default{
    components: {
        Thumbnail, EmptyTip, ModifySalaryDialog
    },
    mixins: [SelectMapMixin],
    data () {
        return {
            baseInfo: null,  // 基本信息
            evaInfo: null,
            formKey: 1,
            showEdit: false,
            interviews: [],
            turn: null,
            dialogVisible: false,
            interviewInfo: {
                interviewArrangeId: null,
                evaluator: ''
            },
            dialogInfo: {
                extInfo: ''
            },
            form: {
                status: '',
                content: ''
            }
        }
    },
    created () {
        this.getPhaseInfo()
        this.getEvaList()
    },
    methods: {
        getPhaseInfo () {
            this.$axios.post('/resumePosition/interviewArrange/getListWithOutEva.api', {resumePositionId: this.$route.params.id}).then(res => {
                this.baseInfo = res.result
            })
        },
        getEvaList () {
            this.$axios.get('/payment/getEvaList.api?resumePositionId=' + this.$route.params.id).then(res => {
                console.log(res.result instanceof Array)
                this.evaInfo = res.result.list ? res.result : {list: []}
            })
        },
        refresh () {
            this.getEvaList()
        },
        cancelEdit () {
            this.showEdit = false
        },
        showEditPopup (item) {
            this.dialogInfo.extInfo = {}
            this.dialogVisible = true

            this.$nextTick(() => {
                this.$refs.updateForm.$refs.form.$data.updateUrl = '/resume/updateEvaluation.api'
                this.$refs.updateForm.setForm(item)
            })
        }
    }
}
</script>

<style lang="scss">
	@import "./evaluation";
	.evaluation-resume-scoped{
		.mask-tip{
			position: absolute;
			left: 0;
			top: 0;
			background: rgba(0, 0, 0, 0.1);
			text-align: center;
			width: 100%;
			height: 100%;
			z-index: 20;
			p{
				position: absolute;
				width: 100%;
				top: 48%;
			}
		}
		.evaluate-row{
			position: relative;
			padding: 10px 20px;
		}
	}
</style>



// WEBPACK FOOTER //
// salary.vue?7353de5f